if (!customElements.get('product-offers')) {
  customElements.define(
    'product-offers',
    class ProductOffers extends HTMLElement {
      constructor() {
        super();
        this.copyResetTimers = new WeakMap();
      }

      connectedCallback() {
        this.list = this.querySelector('.product-offers__list');
        this.controlsWrapper = this.querySelector('.product-offers__controls');

        this.addEventListener('click', this.handleClick.bind(this));

        if (!this.list || !this.controlsWrapper) return;

        this.list.addEventListener('scroll', this.updateControls.bind(this), { passive: true });

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateControls.bind(this));
          this.resizeObserver.observe(this.list);
        }

        this.updateControls();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      handleClick(event) {
        const copyButton = event.target.closest('[data-offer-code]');
        if (copyButton) {
          this.copyCode(copyButton);
          return;
        }

        const control = event.target.closest('[data-offers-scroll]');
        if (control) {
          this.scrollByCard(control.dataset.offersScroll === 'next' ? 1 : -1);
        }
      }

      scrollByCard(direction) {
        if (!this.list) return;

        const card = this.list.querySelector('.product-offers__item');
        const gap = parseFloat(getComputedStyle(this.list).columnGap) || 0;
        const step = card ? card.offsetWidth + gap : this.list.clientWidth;

        this.list.scrollBy({
          left: step * direction,
          behavior: window.FoxTheme?.config?.disableAnimations ? 'auto' : 'smooth',
        });
      }

      /**
       * The controls are only useful once the cards actually overflow the column,
       * so they stay hidden until then and disable at each end of the scroll.
       */
      updateControls() {
        if (!this.list || !this.controlsWrapper) return;

        const maxScroll = this.list.scrollWidth - this.list.clientWidth;
        const overflows = maxScroll > 1;

        this.controlsWrapper.hidden = !overflows;
        if (!overflows) return;

        // Round to absorb sub-pixel scroll positions from zoom or fractional widths.
        const position = Math.round(Math.abs(this.list.scrollLeft));
        const previous = this.controlsWrapper.querySelector('[data-offers-scroll="previous"]');
        const next = this.controlsWrapper.querySelector('[data-offers-scroll="next"]');

        if (previous) previous.disabled = position <= 0;
        if (next) next.disabled = position >= Math.round(maxScroll) - 1;
      }

      async copyCode(button) {
        const code = button.dataset.offerCode;
        if (!code) return;

        const copied = await this.writeToClipboard(code);
        if (!copied) return;

        clearTimeout(this.copyResetTimers.get(button));
        button.dataset.copied = 'true';
        button.textContent = button.dataset.copiedLabel || 'Copied';

        this.copyResetTimers.set(
          button,
          setTimeout(() => {
            delete button.dataset.copied;
            button.textContent = button.dataset.copyLabel || 'Copy';
          }, 2000)
        );
      }

      async writeToClipboard(text) {
        try {
          await navigator.clipboard.writeText(text);
          return true;
        } catch (error) {
          // Clipboard API is unavailable outside secure contexts, fall back to a selection copy.
          const textarea = document.createElement('textarea');
          textarea.value = text;
          textarea.setAttribute('readonly', '');
          textarea.style.position = 'absolute';
          textarea.style.left = '-9999px';
          document.body.appendChild(textarea);
          textarea.select();

          let succeeded = false;
          try {
            succeeded = document.execCommand('copy');
          } catch (fallbackError) {
            succeeded = false;
          }

          textarea.remove();
          return succeeded;
        }
      }
    }
  );
}
